var Chaplin, Description, Model, ThumbnailPopupView, View, template, _ref,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

template = require('views/templates/thumbnail-popup');

View = require('views/base/view');

Chaplin = require('chaplin');

Model = require('models/base/model');

Description = require('models/description');

module.exports = ThumbnailPopupView = (function(_super) {
  __extends(ThumbnailPopupView, _super);

  function ThumbnailPopupView() {
    _ref = ThumbnailPopupView.__super__.constructor.apply(this, arguments);
    return _ref;
  }

  ThumbnailPopupView.prototype.template = template;

  ThumbnailPopupView.prototype.className = 'popup';

  ThumbnailPopupView.prototype.tagName = 'div';

  ThumbnailPopupView.prototype.id = 'thumbnail-popup';

  ThumbnailPopupView.prototype.autoRender = false;

  ThumbnailPopupView.prototype.container = 'body';

  ThumbnailPopupView.prototype.position = null;

  ThumbnailPopupView.prototype.hideTimeout = null;

  ThumbnailPopupView.prototype.listen = {
    'thumbnails:mouseout mediator': 'startHideTimeout'
  };

  ThumbnailPopupView.prototype.events = {
    'click .btn-close': 'closePopup',
    'click .btn-view': 'goToPage',
    'click .btn-add-to-cart': 'addToCart',
    'mouseenter': 'stopHideTimeout',
    'mouseleave': 'startHideTimeout',
    'click .product-photo': 'hightlightProduct'
  };

  ThumbnailPopupView.prototype.startHideTimeout = function() {
    var _this = this;
    this.hideTimeout = window.setTimeout((function() {
      return _this.closePopup();
    }), 400);
    return false;
  };

  ThumbnailPopupView.prototype.stopHideTimeout = function() {
    window.clearTimeout(this.hideTimeout);
    this.hideTimeout = null;
    return false;
  };

  ThumbnailPopupView.prototype.closePopup = function() {
    this.dispose();
    return false;
  };

  ThumbnailPopupView.prototype.initialize = function(options) {
    var activePage, catalogue, page1, page2;
    ThumbnailPopupView.__super__.initialize.apply(this, arguments);
    activePage = options.activePage;
    this.position = options.position;
    catalogue = Chaplin.mediator.catalogue;
    page1 = _(catalogue.get('pages')).find({
      page_number: activePage[0]
    });
    if (page1 != null) {
      page1.page = (page1 != null ? page1.page_number : void 0) - 1;
    }
    page2 = _(catalogue.get('pages')).find({
      page_number: activePage[1]
    });
    if (page2 != null) {
      page2.page = (page2 != null ? page2.page_number : void 0) - 1;
    }
    if (!(page1 != null ? page1.hotspots : void 0) && !(page2 != null ? page2.hotspots : void 0)) {
      return;
    }
    this.model = new Model({
      page1: page1,
      page2: page2
    });
    return this.render();
  };

  ThumbnailPopupView.prototype.attach = function() {
    ThumbnailPopupView.__super__.attach.apply(this, arguments);
    return this.moveToPosition(this.position);
  };

  ThumbnailPopupView.prototype.moveToPosition = function(position) {
    return this.$el.css({
      'left': position.left - this.$el.width() / 2 + 38,
      'top': position.top - this.$el.height() - 30
    });
  };

  ThumbnailPopupView.prototype.goToPage = function() {
    this.publishEvent('catalogue:goToPage', this.model.get('page1').page_number);
    return false;
  };

  ThumbnailPopupView.prototype.addToCart = function(e) {
    var description;
    description = new Description({
      title: $(e.currentTarget).attr('title')
    });
    description.addToCart();
    this.closePopup();
    return false;
  };

  ThumbnailPopupView.prototype.hightlightProduct = function(e) {
    var hotspot, page, productData,
      _this = this;
    productData = $(e.currentTarget).attr('data-product').split(',');
    page = parseInt(productData[0]);
    hotspot = productData[1];
    this.publishEvent('catalogue:hideAllDescriptions');
    this.publishEvent('catalogue:getActivePage', function(activePages) {
      if ((page === activePages[0]) || (page === activePages[1])) {
        return _this.publishEvent('catalogue:higlelightHotspotByTitle', hotspot);
      } else {
        _this.publishEvent('catalogue:goToPage', page);
        return _this.publishEvent('catalogue:setTurnPageCallback', function() {
          return _this.publishEvent('catalogue:higlelightHotspotByTitle', hotspot);
        });
      }
    });
    return this.closePopup();
  };

  return ThumbnailPopupView;

})(View);
